<template>
  <v-sheet class="px-md-16 py-6" color="blue-darken-4">
    <v-container fluid>
      <v-row class="mb-6" justify="center">
        <v-col class="text-center" cols="12" md="8">
          <h2 class="text-h5 text-sm-h4 font-weight-medium">
            {{ course.name }}
          </h2>

          <TitleParagraphBlock
            v-if="value.title || value.paragraph"
            em-class-title="text-decoration-underline"
            :value="value"
          />
        </v-col>
      </v-row>

      <v-row v-if="course.note_paragraph" class="mb-6">
        <v-col>
          <v-alert color="surface-light" theme="light" type="info">
            <StyledText :value="course.note_paragraph" />
          </v-alert>
        </v-col>
      </v-row>

      <v-item-group multiple>
        <v-item
          v-for="item in items"
          :key="item.key"
          v-slot="{ isSelected, toggle }"
        >
          <v-row dense>
            <v-col>
              <SimpleRevealCard
                :title="item.title"
                :value="isSelected"
                variant="outlined"
                @toggle="toggle"
              >
                <ContentBlock
                  :value="item"
                  class="text-body-1 text-left text-white mb-3"
                  em-class="font-weight-black"
                />
              </SimpleRevealCard>
            </v-col>
          </v-row>
        </v-item>
      </v-item-group>

      <v-row v-if="registerHref" class="mt-6">
        <v-col align="center">
          <v-btn
            :href="registerHref"
            class="text-capitalize font-weight-bold"
            color="secondary"
            target="_blank"
            rounded="pill"
            size="large"
          >
            Register Now
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup>
import { computed } from 'vue'

const ITEM_KEYS = [
  'features_item',
  'learn_item',
  'earn_item',
  'who_item',
  'why_item'
]

const props = defineProps({
  course: {
    required: true,
    type: Object
  },
  registerHref: {
    default: undefined,
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})

const items = computed(() => {
  return ITEM_KEYS.map(key => {
    return Object.assign({ key }, props.value[key], props.course[key])
  }).filter(item => item.list || item.paragraph)
})
</script>
